// components
import AddressContainer from 'components/checkout/containers/address/address-container';

type Step0Props = {
  locale: string;
  ciamId: string;
  sessionId: string;
}

export function Step0({ locale, ciamId, sessionId }: Readonly<Step0Props>) {
  const isLoggedIn = Boolean(ciamId && ciamId !== '');

  return (
    <AddressContainer
      ciamId={ciamId}
      locale={locale}
      isLogged={isLoggedIn}
      sessionId={sessionId}
    />
  );
}
